module.exports = __webpack_public_path__ + "img/e4_img3.6ceaffa.webp";